import CommunityObject from "./CommunityObject";
import Scenario from "./ScenarioObject";
import Tag from "./TagObject";
export default class UserObject extends CommunityObject {
  constructor(user) {
    super(UserObject.name);
    this.id = Number(user.id);
    this.uuid = String(user.uuid_id);

    if (user.username) {
      this.username = String(user.username);
      this.publicUsername = String(user.username);
    }

    if (user.publicUsername) {
      if (!this.username) this.username = String(user.publicUsername);
      this.publicUsername = String(user.publicUsername);
    }
    
    this.is_public = Boolean(user.is_public);
    this.favourited_scenarios = [];
    user.favourited_scenarios.forEach(scenario => {
      this.favourited_scenarios.push(new Scenario(scenario));
    });
    this.validate();
  }
  static toJSON() {
    id: this.id;
    uuid_id: this.uuid_id;
    username: this.username;
    is_public: this.is_public;
    favourited_scenarios: this.favourited_scenarios;
  }
}
